import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: null,
  signature: null,
  tokenExpireTime:  null,
  loading: false,
  error: null,
};

const memberAuthSlice = createSlice({
  name: "memberAuth",
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      const { token, signature, tokenExpireTime } = action.payload;
      state.token = token;
      state.signature = signature;
      state.tokenExpireTime = tokenExpireTime;

  
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      return {
        token: null,
        signature: null,
        tokenExpireTime: null,
        loading: false,
        error: null,
      };
    },
  },
});

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  logout,
} = memberAuthSlice.actions;
export default memberAuthSlice.reducer;
